import {
  ColumnOptionsBase,
  EntityColumn,
  entityColumn,
  GridRef,
  GroupColumnRef,
  ServerSideColumnOption,
  stringColumn
} from '@softapps/core';
import { ProductGroup } from './product-group';
import { Signal } from '@angular/core';
import { Translation } from '@softline/ui-core';
import { ProductGroupColumnComponent } from './product-group-column.component';

export interface ClientSideProductGroupColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, ProductGroup> {
  rowGroup?: boolean;
}

export interface ServerSideProductGroupColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, ProductGroup>, ServerSideColumnOption {
  rowGroup?: boolean;
}

export type ProductGroupColumnOptions<TRow extends object> = ClientSideProductGroupColumnOptions<TRow> | ServerSideProductGroupColumnOptions<TRow>;

export function productGroupColumn<TRow extends object>(ref: GridRef<TRow> | GroupColumnRef<TRow>,
                                                 translator: (key: string) => Signal<Translation>,
                                                 options: ProductGroupColumnOptions<TRow>): EntityColumn<TRow, ProductGroup>{
  return entityColumn(ref, {
    ...options,
    format: v => `${v.produktgruppe} - ${v.bezeichnung}`,
    sortBy: v => v.produktgruppe,
    cellRenderer: ProductGroupColumnComponent,
    serverSideSortField: 'produktgruppe',
  }, entityRef => {
    stringColumn(entityRef, {
      colId: 'number',
      header: translator('Produktgruppe'),
      getValue: v => v.produktgruppe
    });
    stringColumn(entityRef, {
      colId: 'name',
      header: translator('Name'),
      getValue: v => v.bezeichnung
    });
  });
}
